import { useState } from "react";
import { cn } from "../lib/utils";

interface TabItem {
  value: string;
  label: string;
  content: React.ReactNode;
  disabled?: boolean;
}

interface TabsProps {
  items: TabItem[];
  defaultValue?: string;
  className?: string;
}

export function Tabs({ items, defaultValue, className }: TabsProps) {
  const [active, setActive] = useState(defaultValue ?? items[0]?.value ?? "");
  const current = items.find((t) => t.value === active);

  return (
    <div className={cn("tabs", className)}>
      <div role="tablist" className="tabs-list">
        {items.map((item) => (
          <button
            key={item.value}
            role="tab"
            aria-selected={item.value === active}
            disabled={item.disabled}
            className={cn("tabs-trigger", item.value === active && "tabs-trigger-active")}
            onClick={() => !item.disabled && setActive(item.value)}
          >
            {item.label}
          </button>
        ))}
      </div>
      <div role="tabpanel" className="tabs-content">
        {current?.content}
      </div>
    </div>
  );
}
